/**
 * dept
 */
'use strict';
import AppDept from '@/_modules/app_dept';

document.addEventListener('DOMContentLoaded', () => {
  new AppDept();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
